import { cn } from '@/lib/utils'
import { Skeleton } from '@/components/ui/skeleton'

interface MessageSkeletonProps {
  count?: number
  className?: string
}

function SingleMessageSkeleton({ isOwn = false }: { isOwn?: boolean }) {
  return (
    <div
      className={cn(
        "flex mb-3 px-2 md:px-4",
        isOwn ? "justify-end" : "justify-start"
      )}
    >
      <div
        className={cn(
          "rounded-2xl px-4 py-3 max-w-[85%] md:max-w-[75%]",
          isOwn
            ? "bg-violet-600/20 border border-violet-500/20 rounded-br-md"
            : "bg-game-tertiary/50 dark:bg-zinc-800/40 border border-game-border-primary/50 dark:border-zinc-700/30 rounded-bl-md"
        )}
      >
        {/* Nome do usuario */}
        {!isOwn && (
          <div className="flex items-center gap-2 mb-2">
            <Skeleton className="h-4 w-24 bg-game-border-primary/30 dark:bg-zinc-700/50" />
            <Skeleton className="h-5 w-16 rounded-full bg-game-border-primary/20 dark:bg-zinc-700/30" />
          </div>
        )}

        {/* Conteudo da mensagem */}
        <div className="space-y-2">
          <Skeleton className={cn(
            "h-4 bg-game-border-primary/30 dark:bg-zinc-700/50",
            isOwn ? "w-48" : "w-56"
          )} />
          <Skeleton className={cn(
            "h-4 bg-game-border-primary/30 dark:bg-zinc-700/50",
            isOwn ? "w-32" : "w-40"
          )} />
        </div>

        {/* Timestamp */}
        <div className="flex justify-end mt-2">
          <Skeleton className="h-3 w-12 bg-game-border-primary/20 dark:bg-zinc-700/30" />
        </div>
      </div>
    </div>
  )
}

export function MessageSkeleton({ count = 5, className }: MessageSkeletonProps) {
  // Padrão alternado: mensagem do outro, minha, outro, minha...
  const pattern = [false, true, false, false, true, false, true, false]

  return (
    <div className={cn("p-3 md:p-6 space-y-1", className)}>
      {Array.from({ length: count }).map((_, index) => (
        <SingleMessageSkeleton
          key={index}
          isOwn={pattern[index % pattern.length]}
        />
      ))}
    </div>
  )
}
